import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as ProyectoService from 'services/proyecto.service'

import { ZrSwal } from 'utils'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Proyectos' }]

const tableHeaderRows = [{ label: 'CÓDIGO' }, { label: 'DESCRIPCIÓN' }, { label: 'MONEDA' }, { label: '', width: 60 }]

const ListaRolesPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarInsertarActualizarModal, setMostrarInsertarActualizarModal] = React.useState(false)

  const tablaRef = React.useRef(null)
  const editarDataRef = React.useRef({})

  const clickEditar = React.useCallback(
    id => {
      ProyectoService.obtenerxIdAsEdicion(id)
        .then(({ data }) => {
          editarDataRef.current = data
          setMostrarInsertarActualizarModal(true)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    },
    [__zariContext]
  )

  const clickNuevo = React.useCallback(() => {
    editarDataRef.current = {}
    setMostrarInsertarActualizarModal(true)
  }, [])

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        mensaje: 'Seguro que desea eliminar el registro?',
        showCerrar: true,
        tipo: 'error',
        onSuccess: () => {
          ProyectoService.eliminarxId(id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.codigo}</Table.Cell>
        <Table.Cell>{row.descripcion}</Table.Cell>
        <Table.Cell>{row.moneda}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar(row._id)}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar(row._id)}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEditar, clickEliminar]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Proyectos'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            ref={tablaRef}
            url='/proyectos'
            headRows={tableHeaderRows}
            rowTemplate={rowTemplate}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarInsertarActualizarModal && (
        <Modals.InsertarActualizarModal
          show={mostrarInsertarActualizarModal}
          handleClose={() => setMostrarInsertarActualizarModal(false)}
          refreshTable={tablaRef.current.reload}
          editarData={editarDataRef.current}
        />
      )}
    </>
  )
}

export default ListaRolesPage
